import React from 'react';
import {useDispatch} from 'react-redux';
import {getSharingDetailsPopup} from "../../../../../../../../../../../../../../../../../actions/sharingDetailsActions";
import Button from '../../../../../../../../../../../../../../../../components/button';

function AddToLabelButton ({contactId, contactName, contactType, title, disabled}) {

	const dispatch = useDispatch();

    const clickHandler = (e) => {
	    e.stopPropagation();
        dispatch(getSharingDetailsPopup([true, "select_one_label", [{
            'id': e.currentTarget.dataset.contactId,
            'type' : e.currentTarget.dataset.contactType
        }], e.currentTarget.dataset.contactName, true, 'fromAddToLabelButton']));
    };

	return (
		<Button
			className="btn-link"
			title={title || ''}
			data-contact-id={contactId}
			data-contact-name={contactName}
			data-contact-type={contactType}
			onClick={ clickHandler }
			disabled={disabled}
		>
			<div className="more-option-item__picto">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path fill="none" d="M0 0h24v24H0V0z"/>
					<path
						fill="currentColor"
						d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"/>
				</svg>
			</div>
			<div className="more-option-item__text">
				<span>{title}</span>
			</div>
		</Button>
	);
}

export default AddToLabelButton;
